import { section } from '@/neon';
import mobileCarousel from '@/lib/mobile-carousel';

const sel = {
  slider: '[data-slider]',
};

section('featured-collection', {
  onLoad() {
    const slider = this.container.querySelector(sel.slider);
    this.mobileCarousel = mobileCarousel(slider, {
      groupCells: 2,
    });
  },

  onUnload() {
    this.mobileCarousel.destroy();
  },
});
